import { useCallback, useState } from 'react';
import { Button, Modal, Space, DatePicker } from 'antd';
import axios from 'axios';
import secureStorage from '../../../shared/secureStorage';

const { RangePicker } = DatePicker;

export default function MessagingProtocolStatisticalTriggerButton() {
  const [open, setOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [range, setRange] = useState([null, null]);
  const handleDownload = useCallback(async () => {
    setDownloading(true);
    window.antdNotify('推播統計', '推播統計下載中...', 'loading');

    try {
      const accessToken = secureStorage.getItem('irentAccessToken');
      const baseURL =
        process.env.REACT_APP_BASE_URL + '/dashboard' ||
        'http://localhost:8000/dashboard';

      const params = {};
      if (range[0]) params.start_time = range[0].format('YYYY-MM-DD');
      if (range[1]) params.end_time = range[1].format('YYYY-MM-DD');
      const encodedParams = new URLSearchParams(params).toString();
      const response = await axios.get(
        `${baseURL}/messaging_protocol/statistical/lexus?${encodedParams}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          responseType: 'blob',
        }
      );

      const blob = new Blob([response.data], {
        type:
          response.headers['content-type'] ||
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const contentDisposition = response.headers['content-disposition'];
      let fileName = `推播統計_${new Date().toISOString().split('T')[0]}.xlsx`;

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename=(.+)/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/"/g, '');
        }
      }

      // Mount
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Unmount
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      window.antdNotify('推播統計', '推播統計下載成功', 'success');
      setOpen(false);
    } catch (error) {
      console.error(error);
      window.antdNotify('推播統計', '推播統計下載失敗，請稍後再試', 'fail');
    } finally {
      setDownloading(false);
    }
  }, [range]);

  return (
    <>
      <Button onClick={() => setOpen(true)}>推播統計下載</Button>
      <Modal
        title="推播統計下載"
        open={open}
        onOk={handleDownload}
        confirmLoading={downloading}
        onCancel={() => setOpen(false)}>
        <Space direction="vertical" size={4}>
          <p>請選擇統計區間</p>
          <RangePicker
            picker="month"
            cellRender={(date) => (
              <span className="ant-picker-cell-inner">{date.month() + 1}</span>
            )}
            format="YYYY/MM"
            value={range}
            onChange={(value) => setRange(value)}
          />
        </Space>
      </Modal>
    </>
  );
}
